import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import reductio from "reductio";
import { ChartTemplate } from "../chartTemplate";

const valueChart = (divRef, ndx) => {
  const crop_value = ndx.dimension((d) => d.baseTbCode);
  var crop_value_grp = crop_value.groupAll().reduceSum(function (d) {
    return d.crop_Value_KES;
  });

  const valueChart = dc.numberDisplay(divRef);
  valueChart
    .formatNumber(d3.format(","))
    .group(crop_value_grp)
    .valueAccessor((d) => {
      return d;
    });
  return valueChart;
};

export const CropValueChart = (props) => (
  <ChartTemplate chartFunction={valueChart} />
);
